import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import { entitiesRouteRef } from '@spotify/confidence-entities-react';

export enum ExternalRoutesIds {
  entities = 'entities',
  factTablesCreate = 'factTablesCreate',
  entity = 'entity',
  factTable = 'factTable',
  assignmentTable = 'assignmentTable',
  assignmentTablesCreate = 'assignmentTablesCreate',
  metrics = 'metrics',
}

export { entitiesRouteRef };

export const factTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTablesCreate,
  optional: true,
});

export const metricsRouteRef = createRouteRef({ id: 'metrics' });

export const metricRouteRef = createSubRouteRef({
  id: 'metric',
  path: '/:id',
  parent: metricsRouteRef,
});

export const entityRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entity,
  params: ['id'],
  optional: true,
});

export const factTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTable,
  params: ['id'],
  optional: true,
});

export const assignmentTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTable,
  params: ['id'],
  optional: true,
});

export const assignmentTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTablesCreate,
  optional: true,
});

export const metricsExternalRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metrics,
  optional: true,
});
